import React from 'react';
import './PostSkeleton.css';

const PostSkeleton = () => {
  return (
    <div className="post-skeleton">
      <div className="post-skeleton-header">
        <div className="post-skeleton-avatar"></div>
        <div className="post-skeleton-meta">
          <div className="post-skeleton-name"></div>
          <div className="post-skeleton-date"></div>
        </div>
      </div>
      <div className="post-skeleton-body"></div>
      <div className="post-skeleton-body short"></div>
      <div className="post-skeleton-footer"></div>
    </div>
  );
};

export default PostSkeleton;
